"use client";

import type * as React from "react";

import { cn } from "@/lib/utils";

// Match Sessions, with opaque composites so pinned columns match on every canvas.
export const TABLE_ROW_BACKGROUND = "[&>td]:bg-background";
export const TABLE_ROW_STRIPE_BACKGROUND =
  "[&>td]:[background-color:color-mix(in_oklab,hsl(var(--surface))_40%,hsl(var(--background)))]";
export const TABLE_ROW_HOVER_BACKGROUND =
  "hover:[&>td]:[background-color:color-mix(in_oklab,hsl(var(--muted))_50%,hsl(var(--background)))]";

// Sticky column: pinned to the inline start, layered above scrolling cells,
// with a 1px border shadow standing in for a right border that survives the
// sticky offset.
export const TABLE_PINNED_COLUMN =
  "sticky left-0 z-20 shadow-[1px_0_0_0_hsl(var(--border)/0.45)]";

// Sticky header treatment shared by both grids. Layering stays local to each table.
export const TABLE_STICKY_HEADER = "sticky top-0 grid bg-background";

/**
 * The scrolling viewport for a virtualized table grid. Owns the shared
 * min-h-0/flex-1/overflow-auto/scrollbar-thin container styling; accepts
 * className for per-grid extras (e.g. bg-surface).
 */
export function TableScrollContainer({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="table-scroll-container"
      className={cn("min-h-0 flex-1 overflow-auto scrollbar-thin", className)}
      {...props}
    />
  );
}
